import { render, staticRenderFns } from "./review_form.vue?vue&type=template&id=5f3c56c0&scoped=true&"
import script from "./review_form.vue?vue&type=script&lang=js&"
export * from "./review_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3c56c0",
  null
  
)

export default component.exports